import React from 'react';
import classNames, { Argument } from 'classnames';

import { TimeoutResult } from 'types/common';

import Modal from './Modal';

const Popup: React.FC<React.PropsWithChildren<{ duration?: number, onClose?: (value: boolean) => void, title?: React.ReactElement<any>, className?: Argument }>> = ({
  duration = 4000, onClose, title, children, className,
}) => {
  const timeoutId = React.useRef<TimeoutResult>(null);

  const handleOnClose = React.useCallback(() => onClose?.(false), [onClose]);

  React.useEffect(() => {
    timeoutId.current = setTimeout(handleOnClose, duration);
    return () => {
      if (timeoutId.current) {
        clearTimeout(timeoutId.current);
      }
    };
  }, [duration, handleOnClose]);

  return (
    <Modal
      role="alertdialog"
      open
      title={title}
      hideCloseButton
      onClose={handleOnClose}
      className={classNames('modal-large', className)}
    >
      {children}
    </Modal>
  );
};

export default Popup;
